<template>
  <div class="main-custom">
    <Header />
    <div id="printable-consult-search" class="container">
      <b-loading isFullPage :active="isLoading" />
      <h1 class="title spacing-ml-30 spacing-mt-20 has-text-color-7">
        {{ Home.CONSULT_PROCESS }}
      </h1>
      <h2 class="subtitle has-text-color-7 spacing-ml-30">
        {{ General.FIND_YOUR_PROCESS }}
      </h2>

      <MediaShareBar
        :url="currentUrl"
        :title="Home.CONSULT_PROCESS"
        :description="General.FIND_YOUR_PROCESS"
        printId="printable-consult-search"
      />

      <section :class="{ 'spacing-mx-30': !isMobile }">
        <CustomAdvancedSearch
          :class="{ 'spacing-mx-10': !isMobile }"
          isExternalSearch
        />
        <span
          class="has-text-weight-semibold is-clickable"
          :class="{ 'ml-10': !isMobile }"
          @click="goBack"
        >
          <b-icon icon="keyboard-backspace" class="mr-0" />
          {{ General.RETURN }}
        </span>
        <SearchViewDetail
          :process="getSelectedProcess"
          :timeLine="timeLineFilled"
          :processTime="getProcessTime"
          :externalAbbreviation="getExternalAbbreviation"
        />
      </section>
    </div>
    <Footer :isReduced="true" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Header from "@/layout/Header";
import Footer from "@/layout/Footer.vue";
import SearchViewDetail from "@/layout/SearchViewDetail";

import CustomAdvancedSearch from "@/components/CustomAdvancedSearch";
import MediaShareBar from "@/components/MediaShareBar";
import { General, Home } from "@/utils/constants";

export default {
  name: "ConsultSearchDetail",
  components: {
    Header,
    Footer,
    SearchViewDetail,
    CustomAdvancedSearch,
    MediaShareBar
  },

  props: {
    nup: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      General,
      Home,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      getSearchedProcessList: "getSearchedProcessList",
      getTimeLineItens: "getTimeLineItens",
      getProcessTime: "getProcessTime",
      getExternalAbbreviation: "getExternalAbbreviation",
      getFilterList: "getFilterList",
      getCapacityById: "getCapacityById",
      getIsSearchSuite: "getIsSearchSuite",
      isMobile: "isMobile"
    }),

    currentUrl() {
      return window.location.href;
    },

    getSelectedProcess() {
      return this.getSearchedProcessList?.list?.[0];
    },

    timeLineFilled() {
      return this.getTimeLineItens.map(item => ({
        ...item,
        capacity: this.getCapacityById(item.capacity)
      }));
    }
  },

  watch: {
    getFilterList: {
      async handler() {
        if (this.getIsSearchSuite) this.$router.push("/consultar-processo");
        else this.searchViprocProcess(this.getFilterList.search);
      }
    }
  },

  async beforeMount() {
    if (this.getSelectedProcess?.nup !== this.nup)
      await this.searchProcessByFilter({
        filters: {
          nup: this.nup
        },
        page: 1,
        order_by: { date: "desc" }
      });
    if (this.getSelectedProcess?.id)
      await this.publicTimeLine(this.getSelectedProcess.id);
  },

  methods: {
    ...mapActions({
      publicTimeLine: "publicTimeLine",
      searchProcessByFilter: "searchProcessByFilter",
      searchViprocProcess: "searchViprocProcess"
    }),

    goBack() {
      this.$router.push({
        path: "/consultar-processo",
        query: {
          showSingle: true
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 90%;
  padding: 15px 0;
  min-height: 400px;
}
.header-label {
  background-color: var(--app-background-color);
  align-items: center;
  border-radius: 5px !important;
}
.icon {
  margin-right: 0.75rem;
}

@media print {
  .no-print {
    display: none;
  }

  @page {
    margin: 0;
  }
}
</style>
